export const timeZoneAbbrMap: Record<string, string> = {
  "Africa/Abidjan": "GMT",
  "Africa/Accra": "GMT",
  "Africa/Addis_Ababa": "EAT",
  "Africa/Algiers": "CET",
  "Africa/Asmara": "EAT",
  "Africa/Asmera": "EAT",
  "Africa/Bamako": "GMT",
  "Africa/Bangui": "WAT",
  "Africa/Banjul": "GMT",
  "Africa/Bissau": "GMT",
  "Africa/Blantyre": "CAT",
  "Africa/Brazzaville": "WAT",
  "Africa/Bujumbura": "CAT",
  "Africa/Cairo": "EEST",
  "Africa/Casablanca": "+01",
  "Africa/Ceuta": "CEST",
  "Africa/Conakry": "GMT",
  "Africa/Dakar": "GMT",
  "Africa/Dar_es_Salaam": "EAT",
  "Africa/Djibouti": "EAT",
  "Africa/Douala": "WAT",
  "Africa/El_Aaiun": "+01",
  "Africa/Freetown": "GMT",
  "Africa/Gaborone": "CAT",
  "Africa/Harare": "CAT",
  "Africa/Johannesburg": "SAST",
  "Africa/Juba": "CAT",
  "Africa/Kampala": "EAT",
  "Africa/Khartoum": "CAT",
  "Africa/Kigali": "CAT",
  "Africa/Kinshasa": "WAT",
  "Africa/Lagos": "WAT",
  "Africa/Libreville": "WAT",
  "Africa/Lome": "GMT",
  "Africa/Luanda": "WAT",
  "Africa/Lubumbashi": "CAT",
  "Africa/Lusaka": "CAT",
  "Africa/Malabo": "WAT",
  "Africa/Maputo": "CAT",
  "Africa/Maseru": "SAST",
  "Africa/Mbabane": "SAST",
  "Africa/Mogadishu": "EAT",
  "Africa/Monrovia": "GMT",
  "Africa/Nairobi": "EAT",
  "Africa/Ndjamena": "WAT",
  "Africa/Niamey": "WAT",
  "Africa/Nouakchott": "GMT",
  "Africa/Ouagadougou": "GMT",
  "Africa/Porto-Novo": "WAT",
  "Africa/Sao_Tome": "GMT",
  "Africa/Timbuktu": "GMT",
  "Africa/Tripoli": "EET",
  "Africa/Tunis": "CET",
  "Africa/Windhoek": "CAT",
  "America/Adak": "HDT",
  "America/Anchorage": "AKDT",
  "America/Anguilla": "AST",
  "America/Antigua": "AST",
  "America/Araguaina": "-03",
  "America/Argentina/Buenos_Aires": "-03",
  "America/Argentina/Catamarca": "-03",
  "America/Argentina/ComodRivadavia": "-03",
  "America/Argentina/Cordoba": "-03",
  "America/Argentina/Jujuy": "-03",
  "America/Argentina/La_Rioja": "-03",
  "America/Argentina/Mendoza": "-03",
  "America/Argentina/Rio_Gallegos": "-03",
  "America/Argentina/Salta": "-03",
  "America/Argentina/San_Juan": "-03",
  "America/Argentina/San_Luis": "-03",
  "America/Argentina/Tucuman": "-03",
  "America/Argentina/Ushuaia": "-03",
  "America/Aruba": "AST",
  "America/Asuncion": "-03",
  "America/Atikokan": "EST",
  "America/Atka": "HDT",
  "America/Bahia": "-03",
  "America/Bahia_Banderas": "CST",
  "America/Barbados": "AST",
  "America/Belem": "-03",
  "America/Belize": "CST",
  "America/Blanc-Sablon": "AST",
  "America/Boa_Vista": "-04",
  "America/Bogota": "-05",
  "America/Boise": "MDT",
  "America/Buenos_Aires": "-03",
  "America/Cambridge_Bay": "MDT",
  "America/Campo_Grande": "-04",
  "America/Cancun": "EST",
  "America/Caracas": "-04",
  "America/Catamarca": "-03",
  "America/Cayenne": "-03",
  "America/Cayman": "EST",
  "America/Chicago": "CDT",
  "America/Chihuahua": "CST",
  "America/Ciudad_Juarez": "MDT",
  "America/Coral_Harbour": "EST",
  "America/Cordoba": "-03",
  "America/Costa_Rica": "CST",
  "America/Coyhaique": "-03",
  "America/Creston": "MST",
  "America/Cuiaba": "-04",
  "America/Curacao": "AST",
  "America/Danmarkshavn": "GMT",
  "America/Dawson": "MST",
  "America/Dawson_Creek": "MST",
  "America/Denver": "MDT",
  "America/Detroit": "EDT",
  "America/Dominica": "AST",
  "America/Edmonton": "MDT",
  "America/Eirunepe": "-05",
  "America/El_Salvador": "CST",
  "America/Ensenada": "PDT",
  "America/Fort_Nelson": "MST",
  "America/Fort_Wayne": "EDT",
  "America/Fortaleza": "-03",
  "America/Glace_Bay": "ADT",
  "America/Godthab": "-01",
  "America/Goose_Bay": "ADT",
  "America/Grand_Turk": "EDT",
  "America/Grenada": "AST",
  "America/Guadeloupe": "AST",
  "America/Guatemala": "CST",
  "America/Guayaquil": "-05",
  "America/Guyana": "-04",
  "America/Halifax": "ADT",
  "America/Havana": "CDT",
  "America/Hermosillo": "MST",
  "America/Indiana/Indianapolis": "EDT",
  "America/Indiana/Knox": "CDT",
  "America/Indiana/Marengo": "EDT",
  "America/Indiana/Petersburg": "EDT",
  "America/Indiana/Tell_City": "CDT",
  "America/Indiana/Vevay": "EDT",
  "America/Indiana/Vincennes": "EDT",
  "America/Indiana/Winamac": "EDT",
  "America/Indianapolis": "EDT",
  "America/Inuvik": "MDT",
  "America/Iqaluit": "EDT",
  "America/Jamaica": "EST",
  "America/Jujuy": "-03",
  "America/Juneau": "AKDT",
  "America/Kentucky/Louisville": "EDT",
  "America/Kentucky/Monticello": "EDT",
  "America/Knox_IN": "CDT",
  "America/Kralendijk": "AST",
  "America/La_Paz": "-04",
  "America/Lima": "-05",
  "America/Los_Angeles": "PDT",
  "America/Louisville": "EDT",
  "America/Lower_Princes": "AST",
  "America/Maceio": "-03",
  "America/Managua": "CST",
  "America/Manaus": "-04",
  "America/Marigot": "AST",
  "America/Martinique": "AST",
  "America/Matamoros": "CDT",
  "America/Mazatlan": "MST",
  "America/Mendoza": "-03",
  "America/Menominee": "CDT",
  "America/Merida": "CST",
  "America/Metlakatla": "AKDT",
  "America/Mexico_City": "CST",
  "America/Miquelon": "-02",
  "America/Moncton": "ADT",
  "America/Monterrey": "CST",
  "America/Montevideo": "-03",
  "America/Montreal": "EDT",
  "America/Montserrat": "AST",
  "America/Nassau": "EDT",
  "America/New_York": "EDT",
  "America/Nipigon": "EDT",
  "America/Nome": "AKDT",
  "America/Noronha": "-02",
  "America/North_Dakota/Beulah": "CDT",
  "America/North_Dakota/Center": "CDT",
  "America/North_Dakota/New_Salem": "CDT",
  "America/Nuuk": "-01",
  "America/Ojinaga": "CDT",
  "America/Panama": "EST",
  "America/Pangnirtung": "EDT",
  "America/Paramaribo": "-03",
  "America/Phoenix": "MST",
  "America/Port-au-Prince": "EDT",
  "America/Port_of_Spain": "AST",
  "America/Porto_Acre": "-05",
  "America/Porto_Velho": "-04",
  "America/Puerto_Rico": "AST",
  "America/Punta_Arenas": "-03",
  "America/Rainy_River": "CDT",
  "America/Rankin_Inlet": "CDT",
  "America/Recife": "-03",
  "America/Regina": "CST",
  "America/Resolute": "CDT",
  "America/Rio_Branco": "-05",
  "America/Rosario": "-03",
  "America/Santa_Isabel": "PDT",
  "America/Santarem": "-03",
  "America/Santiago": "-04",
  "America/Santo_Domingo": "AST",
  "America/Sao_Paulo": "-03",
  "America/Scoresbysund": "-01",
  "America/Shiprock": "MDT",
  "America/Sitka": "AKDT",
  "America/St_Barthelemy": "AST",
  "America/St_Johns": "NDT",
  "America/St_Kitts": "AST",
  "America/St_Lucia": "AST",
  "America/St_Thomas": "AST",
  "America/St_Vincent": "AST",
  "America/Swift_Current": "CST",
  "America/Tegucigalpa": "CST",
  "America/Thule": "ADT",
  "America/Thunder_Bay": "EDT",
  "America/Tijuana": "PDT",
  "America/Toronto": "EDT",
  "America/Tortola": "AST",
  "America/Vancouver": "PDT",
  "America/Virgin": "AST",
  "America/Whitehorse": "MST",
  "America/Winnipeg": "CDT",
  "America/Yakutat": "AKDT",
  "America/Yellowknife": "MDT",
  "Antarctica/Casey": "+08",
  "Antarctica/Davis": "+07",
  "Antarctica/DumontDUrville": "+10",
  "Antarctica/Macquarie": "AEST",
  "Antarctica/Mawson": "+05",
  "Antarctica/McMurdo": "NZST",
  "Antarctica/Palmer": "-03",
  "Antarctica/Rothera": "-03",
  "Antarctica/South_Pole": "NZST",
  "Antarctica/Syowa": "+03",
  "Antarctica/Troll": "+02",
  "Antarctica/Vostok": "+05",
  "Arctic/Longyearbyen": "CEST",
  "Asia/Aden": "+03",
  "Asia/Almaty": "+05",
  "Asia/Amman": "+03",
  "Asia/Anadyr": "+12",
  "Asia/Aqtau": "+05",
  "Asia/Aqtobe": "+05",
  "Asia/Ashgabat": "+05",
  "Asia/Ashkhabad": "+05",
  "Asia/Atyrau": "+05",
  "Asia/Baghdad": "+03",
  "Asia/Bahrain": "+03",
  "Asia/Baku": "+04",
  "Asia/Bangkok": "+07",
  "Asia/Barnaul": "+07",
  "Asia/Beirut": "EEST",
  "Asia/Bishkek": "+06",
  "Asia/Brunei": "+08",
  "Asia/Calcutta": "IST",
  "Asia/Chita": "+09",
  "Asia/Choibalsan": "+08",
  "Asia/Chongqing": "CST",
  "Asia/Chungking": "CST",
  "Asia/Colombo": "+0530",
  "Asia/Dacca": "+06",
  "Asia/Damascus": "+03",
  "Asia/Dhaka": "+06",
  "Asia/Dili": "+09",
  "Asia/Dubai": "+04",
  "Asia/Dushanbe": "+05",
  "Asia/Famagusta": "EEST",
  "Asia/Gaza": "EEST",
  "Asia/Harbin": "CST",
  "Asia/Hebron": "EEST",
  "Asia/Ho_Chi_Minh": "+07",
  "Asia/Hong_Kong": "HKT",
  "Asia/Hovd": "+07",
  "Asia/Irkutsk": "+08",
  "Asia/Istanbul": "+03",
  "Asia/Jakarta": "WIB",
  "Asia/Jayapura": "WIT",
  "Asia/Jerusalem": "IDT",
  "Asia/Kabul": "+0430",
  "Asia/Kamchatka": "+12",
  "Asia/Karachi": "PKT",
  "Asia/Kashgar": "+06",
  "Asia/Kathmandu": "+0545",
  "Asia/Katmandu": "+0545",
  "Asia/Khandyga": "+09",
  "Asia/Kolkata": "IST",
  "Asia/Krasnoyarsk": "+07",
  "Asia/Kuala_Lumpur": "+08",
  "Asia/Kuching": "+08",
  "Asia/Kuwait": "+03",
  "Asia/Macao": "CST",
  "Asia/Macau": "CST",
  "Asia/Magadan": "+11",
  "Asia/Makassar": "WITA",
  "Asia/Manila": "PST",
  "Asia/Muscat": "+04",
  "Asia/Nicosia": "EEST",
  "Asia/Novokuznetsk": "+07",
  "Asia/Novosibirsk": "+07",
  "Asia/Omsk": "+06",
  "Asia/Oral": "+05",
  "Asia/Phnom_Penh": "+07",
  "Asia/Pontianak": "WIB",
  "Asia/Pyongyang": "KST",
  "Asia/Qatar": "+03",
  "Asia/Qostanay": "+05",
  "Asia/Qyzylorda": "+05",
  "Asia/Rangoon": "+0630",
  "Asia/Riyadh": "+03",
  "Asia/Saigon": "+07",
  "Asia/Sakhalin": "+11",
  "Asia/Samarkand": "+05",
  "Asia/Seoul": "KST",
  "Asia/Shanghai": "CST",
  "Asia/Singapore": "+08",
  "Asia/Srednekolymsk": "+11",
  "Asia/Taipei": "CST",
  "Asia/Tashkent": "+05",
  "Asia/Tbilisi": "+04",
  "Asia/Tehran": "+0330",
  "Asia/Tel_Aviv": "IDT",
  "Asia/Thimbu": "+06",
  "Asia/Thimphu": "+06",
  "Asia/Tokyo": "JST",
  "Asia/Tomsk": "+07",
  "Asia/Ujung_Pandang": "WITA",
  "Asia/Ulaanbaatar": "+08",
  "Asia/Ulan_Bator": "+08",
  "Asia/Urumqi": "+06",
  "Asia/Ust-Nera": "+10",
  "Asia/Vientiane": "+07",
  "Asia/Vladivostok": "+10",
  "Asia/Yakutsk": "+09",
  "Asia/Yangon": "+0630",
  "Asia/Yekaterinburg": "+05",
  "Asia/Yerevan": "+04",
  "Atlantic/Azores": "+00",
  "Atlantic/Bermuda": "ADT",
  "Atlantic/Canary": "WEST",
  "Atlantic/Cape_Verde": "-01",
  "Atlantic/Faeroe": "WEST",
  "Atlantic/Faroe": "WEST",
  "Atlantic/Jan_Mayen": "CEST",
  "Atlantic/Madeira": "WEST",
  "Atlantic/Reykjavik": "GMT",
  "Atlantic/South_Georgia": "-02",
  "Atlantic/St_Helena": "GMT",
  "Atlantic/Stanley": "-03",
  "Australia/ACT": "AEST",
  "Australia/Adelaide": "ACST",
  "Australia/Brisbane": "AEST",
  "Australia/Broken_Hill": "ACST",
  "Australia/Canberra": "AEST",
  "Australia/Currie": "AEST",
  "Australia/Darwin": "ACST",
  "Australia/Eucla": "+0845",
  "Australia/Hobart": "AEST",
  "Australia/LHI": "+1030",
  "Australia/Lindeman": "AEST",
  "Australia/Lord_Howe": "+1030",
  "Australia/Melbourne": "AEST",
  "Australia/NSW": "AEST",
  "Australia/North": "ACST",
  "Australia/Perth": "AWST",
  "Australia/Queensland": "AEST",
  "Australia/South": "ACST",
  "Australia/Sydney": "AEST",
  "Australia/Tasmania": "AEST",
  "Australia/Victoria": "AEST",
  "Australia/West": "AWST",
  "Australia/Yancowinna": "ACST",
  "Brazil/Acre": "-05",
  "Brazil/DeNoronha": "-02",
  "Brazil/East": "-03",
  "Brazil/West": "-04",
  "CET": "CEST",
  "CST6CDT": "CDT",
  "Canada/Atlantic": "ADT",
  "Canada/Central": "CDT",
  "Canada/Eastern": "EDT",
  "Canada/Mountain": "MDT",
  "Canada/Newfoundland": "NDT",
  "Canada/Pacific": "PDT",
  "Canada/Saskatchewan": "CST",
  "Canada/Yukon": "MST",
  "Chile/Continental": "-04",
  "Chile/EasterIsland": "-06",
  "Cuba": "CDT",
  "EET": "EEST",
  "EST": "EST",
  "EST5EDT": "EDT",
  "Egypt": "EEST",
  "Eire": "IST",
  "Etc/GMT": "GMT",
  "Etc/GMT+0": "GMT",
  "Etc/GMT+1": "-01",
  "Etc/GMT+10": "-10",
  "Etc/GMT+11": "-11",
  "Etc/GMT+12": "-12",
  "Etc/GMT+2": "-02",
  "Etc/GMT+3": "-03",
  "Etc/GMT+4": "-04",
  "Etc/GMT+5": "-05",
  "Etc/GMT+6": "-06",
  "Etc/GMT+7": "-07",
  "Etc/GMT+8": "-08",
  "Etc/GMT+9": "-09",
  "Etc/GMT-0": "GMT",
  "Etc/GMT-1": "+01",
  "Etc/GMT-10": "+10",
  "Etc/GMT-11": "+11",
  "Etc/GMT-12": "+12",
  "Etc/GMT-13": "+13",
  "Etc/GMT-14": "+14",
  "Etc/GMT-2": "+02",
  "Etc/GMT-3": "+03",
  "Etc/GMT-4": "+04",
  "Etc/GMT-5": "+05",
  "Etc/GMT-6": "+06",
  "Etc/GMT-7": "+07",
  "Etc/GMT-8": "+08",
  "Etc/GMT-9": "+09",
  "Etc/GMT0": "GMT",
  "Etc/Greenwich": "GMT",
  "Etc/UCT": "UTC",
  "Etc/UTC": "UTC",
  "Etc/Universal": "UTC",
  "Etc/Zulu": "UTC",
  "Europe/Amsterdam": "CEST",
  "Europe/Andorra": "CEST",
  "Europe/Astrakhan": "+04",
  "Europe/Athens": "EEST",
  "Europe/Belfast": "BST",
  "Europe/Belgrade": "CEST",
  "Europe/Berlin": "CEST",
  "Europe/Bratislava": "CEST",
  "Europe/Brussels": "CEST",
  "Europe/Bucharest": "EEST",
  "Europe/Budapest": "CEST",
  "Europe/Busingen": "CEST",
  "Europe/Chisinau": "EEST",
  "Europe/Copenhagen": "CEST",
  "Europe/Dublin": "IST",
  "Europe/Gibraltar": "CEST",
  "Europe/Guernsey": "BST",
  "Europe/Helsinki": "EEST",
  "Europe/Isle_of_Man": "BST",
  "Europe/Istanbul": "+03",
  "Europe/Jersey": "BST",
  "Europe/Kaliningrad": "EET",
  "Europe/Kiev": "EEST",
  "Europe/Kirov": "MSK",
  "Europe/Kyiv": "EEST",
  "Europe/Lisbon": "WEST",
  "Europe/Ljubljana": "CEST",
  "Europe/London": "BST",
  "Europe/Luxembourg": "CEST",
  "Europe/Madrid": "CEST",
  "Europe/Malta": "CEST",
  "Europe/Mariehamn": "EEST",
  "Europe/Minsk": "+03",
  "Europe/Monaco": "CEST",
  "Europe/Moscow": "MSK",
  "Europe/Nicosia": "EEST",
  "Europe/Oslo": "CEST",
  "Europe/Paris": "CEST",
  "Europe/Podgorica": "CEST",
  "Europe/Prague": "CEST",
  "Europe/Riga": "EEST",
  "Europe/Rome": "CEST",
  "Europe/Samara": "+04",
  "Europe/San_Marino": "CEST",
  "Europe/Sarajevo": "CEST",
  "Europe/Saratov": "+04",
  "Europe/Simferopol": "MSK",
  "Europe/Skopje": "CEST",
  "Europe/Sofia": "EEST",
  "Europe/Stockholm": "CEST",
  "Europe/Tallinn": "EEST",
  "Europe/Tirane": "CEST",
  "Europe/Tiraspol": "EEST",
  "Europe/Ulyanovsk": "+04",
  "Europe/Uzhgorod": "EEST",
  "Europe/Vaduz": "CEST",
  "Europe/Vatican": "CEST",
  "Europe/Vienna": "CEST",
  "Europe/Vilnius": "EEST",
  "Europe/Volgograd": "MSK",
  "Europe/Warsaw": "CEST",
  "Europe/Zagreb": "CEST",
  "Europe/Zaporozhye": "EEST",
  "Europe/Zurich": "CEST",
  "GB": "BST",
  "GB-Eire": "BST",
  "GMT": "GMT",
  "GMT+0": "GMT",
  "GMT-0": "GMT",
  "GMT0": "GMT",
  "Greenwich": "GMT",
  "HST": "HST",
  "Hongkong": "HKT",
  "Iceland": "GMT",
  "Indian/Antananarivo": "EAT",
  "Indian/Chagos": "+06",
  "Indian/Christmas": "+07",
  "Indian/Cocos": "+0630",
  "Indian/Comoro": "EAT",
  "Indian/Kerguelen": "+05",
  "Indian/Mahe": "+04",
  "Indian/Maldives": "+05",
  "Indian/Mauritius": "+04",
  "Indian/Mayotte": "EAT",
  "Indian/Reunion": "+04",
  "Iran": "+0330",
  "Israel": "IDT",
  "Jamaica": "EST",
  "Japan": "JST",
  "Kwajalein": "+12",
  "Libya": "EET",
  "MET": "CEST",
  "MST": "MST",
  "MST7MDT": "MDT",
  "Mexico/BajaNorte": "PDT",
  "Mexico/BajaSur": "MST",
  "Mexico/General": "CST",
  "NZ": "NZST",
  "NZ-CHAT": "+1245",
  "Navajo": "MDT",
  "PRC": "CST",
  "PST8PDT": "PDT",
  "Pacific/Apia": "+13",
  "Pacific/Auckland": "NZST",
  "Pacific/Bougainville": "+11",
  "Pacific/Chatham": "+1245",
  "Pacific/Chuuk": "+10",
  "Pacific/Easter": "-06",
  "Pacific/Efate": "+11",
  "Pacific/Enderbury": "+13",
  "Pacific/Fakaofo": "+13",
  "Pacific/Fiji": "+12",
  "Pacific/Funafuti": "+12",
  "Pacific/Galapagos": "-06",
  "Pacific/Gambier": "-09",
  "Pacific/Guadalcanal": "+11",
  "Pacific/Guam": "ChST",
  "Pacific/Honolulu": "HST",
  "Pacific/Johnston": "HST",
  "Pacific/Kanton": "+13",
  "Pacific/Kiritimati": "+14",
  "Pacific/Kosrae": "+11",
  "Pacific/Kwajalein": "+12",
  "Pacific/Majuro": "+12",
  "Pacific/Marquesas": "-0930",
  "Pacific/Midway": "SST",
  "Pacific/Nauru": "+12",
  "Pacific/Niue": "-11",
  "Pacific/Norfolk": "+11",
  "Pacific/Noumea": "+11",
  "Pacific/Pago_Pago": "SST",
  "Pacific/Palau": "+09",
  "Pacific/Pitcairn": "-08",
  "Pacific/Pohnpei": "+11",
  "Pacific/Ponape": "+11",
  "Pacific/Port_Moresby": "+10",
  "Pacific/Rarotonga": "-10",
  "Pacific/Saipan": "ChST",
  "Pacific/Samoa": "SST",
  "Pacific/Tahiti": "-10",
  "Pacific/Tarawa": "+12",
  "Pacific/Tongatapu": "+13",
  "Pacific/Truk": "+10",
  "Pacific/Wake": "+12",
  "Pacific/Wallis": "+12",
  "Pacific/Yap": "+10",
  "Poland": "CEST",
  "Portugal": "WEST",
  "ROC": "CST",
  "ROK": "KST",
  "Singapore": "+08",
  "Turkey": "+03",
  "UCT": "UTC",
  "US/Alaska": "AKDT",
  "US/Aleutian": "HDT",
  "US/Arizona": "MST",
  "US/Central": "CDT",
  "US/East-Indiana": "EDT",
  "US/Eastern": "EDT",
  "US/Hawaii": "HST",
  "US/Indiana-Starke": "CDT",
  "US/Michigan": "EDT",
  "US/Mountain": "MDT",
  "US/Pacific": "PDT",
  "US/Samoa": "SST",
  "UTC": "UTC",
  "Universal": "UTC",
  "W-SU": "MSK",
  "WET": "WEST",
  "Zulu": "UTC",
};